import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  smallDialog?: boolean;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => {
  return createStyles({
    container: {
      padding: '20px',
    },
    closeContainer: {
      position: 'sticky',
      top: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    closeIcon: {
      cursor: 'pointer',
    },
    dialogContainer: {
      zIndex: 1299,
    },
    dialogPaper: {
      maxWidth: 800,
      width: ({ smallDialog }) => (smallDialog ? 430 : '100%'),
    },
  });
});
